import { Link } from "react-router";
import logoFooterEE from "@assets/events-awards/ee/logo-footer-ee.png";
import logoFooterEE2 from "@assets/events-awards/ee/logo-footer-ee-2.png";
import { EE_FOOTER_MENU } from "@ee/utils/constants";
import FooterMenuLinks from "@events-awards/components/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_EE_PATH } from "@events-awards/utils/constants";

/**
 * Component to display footer for mobile view in EE pages
 */
const EEFooterMobile = (): React.ReactElement => {
  return (
    <div
      className="w-full pb-2 text-center"
      data-testid="ee-footer-mobile-component"
    >
      <div className="mb-12 flex w-full flex-col items-start justify-center">
        <Link to={EVENTS_AWARDS_EE_PATH} reloadDocument>
          <img
            src={logoFooterEE}
            alt="Emerging Enterprise Awards logo"
            width={169}
            height={99}
            className="mb-6"
          />
          <img
            src={logoFooterEE2}
            alt="Emerging Enterprise Awards logo"
            width={168}
            height={98}
          />
        </Link>
      </div>

      <div>
        <h3 className="mb-2 text-left font-poppins text-base font-semibold tracking-widest">
          About Us
        </h3>

        <p className="text-left text-base leading-[1.4] text-white">
          No annual award better honours the bold ambition of young businesses
          under ten years old than the Emerging Enterprise Award and the
          Emerging Enterprise Sustainability Award. Since 2008, the award has
          been empowering startups and young enterprises with both recognition
          and resources to take flight and achieve stellar growth.
        </p>
      </div>

      <div className="-mx-0 mt-12 flex w-full flex-row">
        <div className="w-1/2">
          <h3 className="mb-4 text-left font-public-sans text-base font-semibold">
            Sections
          </h3>

          <FooterMenuLinks
            items={EE_FOOTER_MENU.slice(0, 6)}
            className="space-y-4"
          />
        </div>

        <div className="w-1/2 pl-3">
          <h3 className="mb-4 text-left font-public-sans text-base font-semibold">
            Quick Links
          </h3>

          <FooterMenuLinks
            items={EE_FOOTER_MENU.slice(6, 9)}
            className="space-y-4"
          />
        </div>
      </div>
    </div>
  );
};

export default EEFooterMobile;
